import { ref, watch, type Ref } from 'vue'
import type { Breadcrumb } from '../types'

const breadcrumbs = ref<Breadcrumb>({
  title: '',
  backButton: undefined,
  subtitle: undefined,
})

export const useBreadcrumbs = () => {
  return breadcrumbs
}

export const useInjectedBreadcrumbs = (breadcrumbProp: Ref<Breadcrumb>) => {
  watch(
    breadcrumbProp,
    () => {
      breadcrumbs.value = breadcrumbProp.value
    },
    {
      deep: true,
      immediate: true,
    }
  )
}
